import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { InsuranceServicesTypeService } from '@services/data-source-tables/insurance-services-type.service';
import { InsuranceServiceTypeModel } from '@/models/tables/insurance-service-type.model';

@Component({
  selector: 'app-button-insurance-service-type-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteInsuranceServiceTypeComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private insuranceServiceTypeModel: InsuranceServiceTypeModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected insuranceServicesTypeService: InsuranceServicesTypeService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.insuranceServiceTypeModel = <InsuranceServiceTypeModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSubAgent) => {
      if (deleteSubAgent) {
        this.insuranceServicesTypeService
          .deleteInsuranceServiceType(this.insuranceServiceTypeModel.id)
          .subscribe({
            next: () => {
              this.toastr.success('Servizio assicurativo cancellato correttamente!');

              Registry.getInstance()
                .get('InsuranceServiceTypeComponent')
                .loadInsuranceServiceTypes();
            },
            error: (error) => {
              LoggerService.error('deleteInsuranceServiceType failed!');
              LoggerService.error(error);

              this.toastr.error(`Errore durante la cancellazione del Servizio assicurativo.`);
            },
            complete: () => {
              LoggerService.log('Request done');
            },
          });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title =
      'Confermi di voler cancellare questa Servizio assicurativo?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata questa Servizio assicurativo non sarà più possibile recuperarla.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
